/**
 * Represents the format of a report.
 */
export enum ReportFormat {
  PPTX = 'pptx',
  PDF = 'pdf',
  DOCX = 'docx'
}
